import { all, fork, takeEvery } from 'redux-saga/effects';
import { types } from './reducer';
import pagination from '@iso/lib/helpers/pagination';
import TypeService from '@iso/services/SettingsService/ProductService/TypeService';

function* watchFetchProductTypes() {
    yield takeEvery(
        types.REQUEST_FETCH_PRODUCT_TYPES,
        pagination('productTypes').saga(TypeService),
    );
}

function* paginationSaga() {
    yield all([
        fork(watchFetchProductTypes),
    ]);
}

export default paginationSaga;